// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"a4fc6cc3","302":"b7d98461","453":"6b1f6dec","454":"9d11da8b","535":"bd349fc2","705":"b7065fbe","824":"273612d9","991":"f4b6885e"}[chunkId] + ".chunk.js";
};